import React from "react";
import { useRechargeCooldown } from "@/store/rechargeCooldown";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";

// Keep the action recognizable and avoid announcing every tick to screen readers.
export default function RechargeCooldownLabel({ children, cooldownLabel }: {
  children?: string;
  cooldownLabel?: string;
}) {
  const { remainingSeconds } = useRechargeCooldown();
  const { t } = useTranslationPlus();
  return <span>{remainingSeconds > 0
    ? t("Wallet.RechargeCooldownLabel", { label: cooldownLabel ?? children ?? "", seconds: remainingSeconds })
    : children}</span>;
}
